import { toast as sonnerToast } from "sonner";
import { apiErrorMessage } from "@/lib/messages";

type ToastErrorMessage = Parameters<typeof sonnerToast.error>[0];
type ToastErrorOptions = Parameters<typeof sonnerToast.error>[1];
type ToastSuccessMessage = Parameters<typeof sonnerToast.success>[0];
type ToastSuccessOptions = Parameters<typeof sonnerToast.success>[1];

function explainError(message: ToastErrorMessage, options?: ToastErrorOptions): ToastErrorMessage {
  if (typeof message !== "string" || options?.description) {
    return message;
  }

  const text = message.trim();
  if (!text) {
    return "A operação não foi concluída.";
  }

  if (/^(erro|falha|não foi possível|nao foi possivel|não foi concluída|nao foi concluida)/i.test(text)) {
    return text.replace(/^erro ao\b/i, "Não foi possível").replace(/\.$/, "");
  }

  return text;
}

/**
 * Borda única para os toasts do produto: erros vindos da API recebem contexto
 * e instrução de próximo passo, sem expor mensagens técnicas.
 */
export const toast = {
  error(message: ToastErrorMessage, options?: ToastErrorOptions) {
    const description = options?.description
      ?? (typeof message === "string"
        ? "Confira os dados e tente novamente. Se persistir, informe a tela e o horário ao suporte."
        : apiErrorMessage(message));
    return sonnerToast.error(explainError(message, options), { ...options, description });
  },
  success(message: ToastSuccessMessage, options?: ToastSuccessOptions) {
    return sonnerToast.success(message, {
      ...options,
      description: options?.description ?? "A alteração foi concluída e os dados foram atualizados.",
    });
  },
  info: sonnerToast.info,
  warning: sonnerToast.warning,
};
